<script setup lang="ts">
import type { EmailVariable } from '../constants/variables'

defineProps<{
  items: EmailVariable[]
  activeIndex: number
}>()

const emit = defineEmits<{
  (e: 'select', variable: EmailVariable): void
  (e: 'hover', index: number): void
}>()

const { t } = useI18n()
</script>

<template>
  <div class="w-64 overflow-hidden rounded-lg border border-border bg-white p-1 shadow-lg">
    <div v-if="items.length === 0" class="px-3 py-2 text-sm text-muted-foreground">
      {{ t('pages.email.emailTemplateCreatePage.noVariableFound') }}
    </div>
    <button
      v-for="(variable, index) in items"
      :key="variable.key"
      type="button"
      class="flex w-full items-center rounded-md px-2 py-1.5 text-left text-sm text-foreground transition-colors"
      :class="index === activeIndex ? 'bg-muted' : 'hover:bg-muted/50'"
      @mousedown.prevent="emit('select', variable)"
      @mouseenter="emit('hover', index)"
    >
      {{ variable.label }}
    </button>
  </div>
</template>
